import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Keyboard, ScreenShare, Assignment, BallotRounded } from "@material-ui/icons";
import { formatMessage, MainMenuContribution, withModulesManager } from "@openimis/fe-core";

// Unique contribution key
const ACCREDITATION_MAIN_MENU_CONTRIBUTION_KEY = "quality_assurance_and_accreditation.MainMenu";

class AccreditationMainMenu extends Component {
  render() {
    const { rights, modulesManager, intl } = this.props;
    const entries = [];

    // Add Accreditation menu
    entries.push({
      text: formatMessage(intl, "quality_assurance_and_accreditation", "menu.accreditation"),
      icon: <Keyboard />,
      route: "/accreditation/",
      id: "qaMenu.accreditation",
    });

    // Add Quality Assurance menu
    entries.push({
      text: formatMessage(intl, "quality_assurance_and_accreditation", "menu.qa"),
      icon: <Assignment />,
      route: "/quality-assurance",
      id: "qaMenu.qualityAssurance",
    });

    // Add Forms menu
    entries.push({
      text: formatMessage(intl, "quality_assurance_and_accreditation", "menu.forms"),
      icon: <BallotRounded />,
      route: "/forms",
      id: "qaMenu.forms",
    });

    // Add any additional entries from module contributions
    const contribs = modulesManager.getContribs(ACCREDITATION_MAIN_MENU_CONTRIBUTION_KEY);
    entries.push(...contribs.filter((c) => !c.filter || c.filter(rights)));

    if (!entries.length) return null;

    return (
      <MainMenuContribution
        {...this.props}
        header={formatMessage(intl, "quality_assurance_and_accreditation", "mainMenu")}
        icon={<ScreenShare />}
        entries={entries}
        menuId="QualityAssuranceAndAccreditationMainMenu" // ✅ UNIQUE menuId
      />
    );
  }
}

const mapStateToProps = (state) => ({
  rights: state?.core?.user?.i_user?.rights || [],
});

export default withModulesManager(injectIntl(connect(mapStateToProps)(AccreditationMainMenu)));
